export default "__VITE_ASSET__xoE1pXHI__"